import React from "react";

import { setTrackHeight } from "../redux/actions";
import { selectTrackHeight } from "../redux/selectors";
import { connect } from "react-redux";
import Resizable from "re-resizable";

class TrackResizer extends React.Component {
    render() {
        return (
            <Resizable
                className="TrackResizer"
                defaultSize={{
                    height: this.props.trackHeight
                }}
                minHeight={120}
                enable={{
                    top: false,
                    right: false,
                    bottom: true,
                    left: false,
                    topRight: false,
                    bottomRight: false,
                    bottomLeft: false,
                    topLeft: false
                }}
                onResizeStop={(event, direction, ref, delta) => {
                    this.props.setTrackHeight(
                        this.props.parentTrackIndex,
                        this.props.childTrackIndex,
                        parseInt(ref.style.height.split("px")[0], 10)
                    );
                }}
            >
                {this.props.children}
            </Resizable>
        );
    }
}

export default connect(
    (store, props) => {
        return {
            trackHeight: selectTrackHeight(
                props.parentTrackIndex,
                props.childTrackIndex
            )(store)
        };
    },
    { setTrackHeight }
)(TrackResizer);
